  <template>
    <modal name="export-ad" height="auto" :width="880" :pivotX="windowWidth > 970 ? 0 : 0.5" :pivotY=".15" @before-open="assignParams">

    <aside class="window window--large window--padding-less export-ad">
      <section class="window__content window__content--two-columns">

        <aside class="window__side">
          <header class="window__header">
            <h1 class="window__title">Export creative</h1>
            <h2 class="window__description"><span class="window__description__prefix">{{ name }}</span> - {{ getformatName }}</h2>
          </header>

          <section class="export">

            <select class="export__select select" style="display: none;">
              <option class="select__option" value="">Fixed (300x250)</option>
              <option class="select__option" value="">Fixed (300x600)</option>
              <option class="select__option" value="">Fixed (728x90)</option>
              <option class="select__option" value="">Fixed (800x600)</option>
              <option class="select__option" value="">Fixed (970x250)</option>
              <option class="select__option" value="">Flexible (4:1)</option>
            </select>

            <div v-if="isInPageAd">
              <router-link :to="{ path: '/clientpreview', query: { format_id: getFormatId, placement_id: getPlacementId }}" class="export__link link link--small" @click.native="publicPreview">Client Preview Page</router-link> | <a class="export__link link link--small" :href="zip_url" target="_blank">Download as Zip</a>
            </div>
            <!-- Ugly formatted, but needed for proper rendering in browser -->
            <div class="export__input input">
              <textarea ref="code" readonly class="export__input__field input__field" v-model="code"></textarea>
            </div>

            <a href="#" class="export__link link link--small" v-clipboard:copy="code" v-clipboard:success="onCopy" v-clipboard:error="onError">Copy Embed Code to Clipboard</a>

            <div v-if="share_url && banner && !banner.update_rule_id && !isFormatUpdateable">
              <div class="export__input input">
                <textarea ref="share" readonly class="export__input__field export__share__field input__field" v-model="share_url"></textarea>
              </div>

              <a href="#" class="export__link link link--small" v-clipboard:copy="share_url" v-clipboard:success="onCopy" v-clipboard:error="onError">Copy Share and Edit Link to Clipboard</a>

              <a href="#" @click="shareAd" class="export__button button button--ghost">Share Ad via Email</a>
            </div>
            <div v-if="!share_url && banner && !banner.update_rule_id">
              <br>
              <div class="export__input input">
                <div class="window__description">Want to share the ad? <br> <a href="#" @click="upgradeAccount" class="export__link link">Upgrade your account</a> Allow other users to edit your ad via a share link!</div>
              </div>
            </div>

            <a href="#" v-on:click.prevent="hide" class="export__button button button--primary button--expand">I'm done here</a>

          </section>


        </aside>

        <section class="window__preview">
          <div class="window__preview__inner">
            <preview-settings :ad="banner" :inputs="inputs"></preview-settings>
          </div>
        </section>
      </section>
    </aside>
  </modal>
</template>

<script>
import {mapState} from 'vuex'
const util = require('../../lib/util');

export default {
  name: 'ExportAdModal',
  props: ['code', 'share_url', 'banner'],

  mounted () {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  },
  methods: {
    assignParams (event) {
      this.banner = event.params;
      this.banner.inputs = this.inputs = this.banner.json;
      this.banner.code = window.ParkAve.getTag(this.banner);
      if (this.banner.share_code) {
        this.banner.share_url = util.baseUrl(`/configuration/${ this.banner.format_id }/${ this.banner.id }/?share_code=` + this.banner.share_code || '');
      }

      this.zip_url = util.apiBaseUrl(`/advertisements/${ this.banner.id }/zip?id=` + this.banner.id);

      this.share_url = this.banner.share_url;
      this.code = this.banner.code;
      this.name = this.banner.name;
      this.formatName = this.banner.format_id;
    },
    hide () {
      this.$modal.hide('export-ad')
    },
    onCopy () {
      let rootVM = window.rootVM;
      rootVM.$snotify.success('Copied');
    },
    onError (e) {
    },
    shareAd () {
      let share_url = this.share_url;
      this.$modal.show('userinput', {
        modalTitle: 'Share Advertisement',
        messageText: 'Enter the email of the user you want to share this ad with: ',
        fieldType: 'email',
        fieldPlaceholder: 'example@parkave.com',
        buttonText: 'Share Ad',
        callback (value) {
          this.$modal.hide('userinput');
          store.dispatch('advertisements/share', {email: value, url: share_url});
        }
      });
    },
    upgradeAccount () {
      this.hide();
      this.$modal.show('pricing', this.plans)
    },
    publicPreview () {
      this.hide();
    }
  },
  computed: {
    ...mapState(['plans']),
    getFormatId () {
      if (this.banner) {
        return this.banner.format_id
      } else {
        return null
      }
    },
    getPlacementId () {
      if (this.banner) {
        return this.banner.placement_id
      } else {
        return null
      }
    },
    isFormatUpdateable () {
      let format;
      let formats = this.$store.getters['formats/formats'];
      for (var i = 0; i < formats.length; i++) {
        if (formats[i].id == this.banner.format_id) {
          format = formats[i];
        }
      }
      return format.updateable;
    },
    getformatName () {
      let formats = this.$store.getters['formats/formats'];
      for (var i = 0; i < formats.length; i++) {
        if (formats[i].id == this.formatName) {
          this.formatName = formats[i].name;
        }
      }
      return this.formatName;
    },
    isInPageAd () {
      if (this.inputs.size) {
        return true
      } else {
        return false
      }
    }
  },
  data(){
    let obj = {
      inputs: {},
      name: '',
      formatName: '',
      windowWidth: window.innerWidth,
    }
    return obj;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/ExportAd.vue